var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-row",
        { staticClass: "mb14" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleContract(2, 1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("customer.addrenewal")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.renewCensusData.length > 0
        ? _c(
            "div",
            { staticClass: "renewal-content" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { staticClass: "over-text", attrs: { span: 20 } },
                    _vm._l(_vm.renewCensusData, function (item) {
                      return _c("p", { key: item.cate_id }, [
                        _c("span", [
                          _vm._v(_vm._s(item.renew ? item.renew.title : "")),
                        ]),
                        _vm._v(" "),
                        item.end_date !== "0000-00-00 00:00:00"
                          ? _c("span", { class: _vm.getRenewDate(item.date) }, [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(item.end_date)
                                    .format("yyyy-MM-DD")
                                )
                              ),
                            ])
                          : _c("span", [_vm._v("--")]),
                        _vm._v("\n          到期\n        "),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "text-right", attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "text" },
                          on: { click: _vm.handleRenewCensus },
                        },
                        [
                          _vm._v("查看全部 "),
                          _c("i", { staticClass: "el-icon-d-arrow-right" }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", height: "90%" },
          attrs: { data: _vm.renewData },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "end_date",
              label: _vm.$t("customer.renewaldate"),
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.end_date !== "0000-00-00 00:00:00"
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$moment(scope.row.end_date)
                                .format("YYYY-MM-DD")
                            )
                          ),
                        ])
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "num",
              label: _vm.$t("customer.renewalamount"),
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "renew.title",
              label: _vm.$t("customer.renewaltype"),
              "min-width": "110",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: _vm.$t("customer.accessstatus"),
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", size: "mini" } },
                          [_vm._v(" " + _vm._s(_vm.$t("customer.audit")) + " ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("customer.passed")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status == -1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v(" 撤回")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 2
                      ? _c(
                          "el-popover",
                          { attrs: { trigger: "hover", placement: "top" } },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("customer.reason")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(scope.row.fail_msg))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("customer.fail")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "card.name",
              label: _vm.$t("setting.info.founder"),
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              "min-width": "160",
              label: _vm.$t("public.operation"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status !== 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleContract(2, 2, scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  scope.row.status == 0 ? "编辑" : "重新提交"
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.setRemarks(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.remarks")))]
                    ),
                    _vm._v(" "),
                    scope.row.status == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("撤回")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.renewData.length > 0
        ? _c(
            "div",
            { staticClass: "block mt10 text-right" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.renewPage,
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.renewTotal,
                },
                on: { "current-change": _vm.renewChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("contract-dialog", {
        ref: "contractDialog",
        attrs: { config: _vm.configContract },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("mark-dialog", {
        ref: "markDialog",
        attrs: { config: _vm.configMark },
        on: { isMark: _vm.isOk },
      }),
      _vm._v(" "),
      _c("renew-census", {
        ref: "renewCensus",
        attrs: { config: _vm.configRenewCensus },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }